export default __webpack_public_path__ + "static/media/leftIcon.2f284d78.svg";